var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"ssv-title__secondary"},[_vm._v("Kontakty pro vyřízení objednávky")]),_vm._v(" "),_c('ssv-order-contact-information-form',_vm._b({ref:"contactInformationForm"},'ssv-order-contact-information-form',_vm.$props,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703ccaea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ssv-order/contact-information/ContactInformationContainer.vue
// module id = null
// module chunks = 